import { useState } from 'react'
import { suggestHandle } from '../lib/places'
import { rememberPrepared } from '../lib/images'
import type { ProfileFields as Fields } from '../types'
import { ImageField } from './ImageField'

type Props = {
  value: Fields
  onChange: (patch: Partial<Fields>) => void
  disabled?: boolean
  // Inside a place's form, where the place has its own name.
  ofPlace?: boolean
  onPendingImage: (pending: boolean) => void
  onError: (message: string) => void
}

// A profile's page in the app: name, @, photo, bio and links (PRD.md, item
// 98), the same in Perfis, in a place's form and inside an event. The @
// follows the name until it is changed.
export function ProfileFields({ value, onChange, disabled, ofPlace, onPendingImage, onError }: Props) {
  const [handleEdited, setHandleEdited] = useState(Boolean(value.handle) && value.handle !== suggestHandle(value.name))
  const text = (key: keyof Fields) => (event: { target: { value: string } }) =>
    onChange({ [key]: key === 'name' ? event.target.value : event.target.value || null })

  return (
    <div className="form-grid">
      <label className="field"><span>{ofPlace ? 'Nome do perfil *' : 'Nome *'}</span><input disabled={disabled} value={value.name} onChange={(event) => {
        const name = event.target.value
        onChange(handleEdited ? { name } : { name, handle: suggestHandle(name) || null })
      }} placeholder="Ex.: Samba do Trabalhador" /></label>
      <label className="field"><span>{ofPlace ? '@ do perfil' : '@ *'}</span><input disabled={disabled} value={value.handle ?? ''} onChange={(event) => { setHandleEdited(true); onChange({ handle: event.target.value || null }) }} placeholder="sambadotrabalhador" /><small>De 3 a 30 letras minúsculas, números, ponto ou sublinhado. Se um perfil do app usar esse @, ele recebe outro.</small></label>
      <ImageField
        label="Foto do perfil"
        imageUrl={value.image_url}
        linkValue={value.image_url_source}
        disabled={disabled}
        onImported={(preview, link, prepared) => { rememberPrepared(preview, prepared); onChange({ image_url: preview, image_url_source: link }) }}
        onPendingChange={onPendingImage}
        onError={onError}
      />
      <label className="field field--wide"><span>Bio</span><textarea disabled={disabled} rows={4} value={value.bio ?? ''} onChange={text('bio')} placeholder="Conte em poucas linhas quem é." /></label>
      <label className="field"><span>Instagram</span><input disabled={disabled} type="url" value={value.instagram_url ?? ''} onChange={text('instagram_url')} placeholder="https://instagram.com/…" /></label>
      <label className="field"><span>TikTok</span><input disabled={disabled} type="url" value={value.tiktok_url ?? ''} onChange={text('tiktok_url')} placeholder="https://tiktok.com/@…" /></label>
      <label className="field field--wide"><span>Site</span><input disabled={disabled} type="url" value={value.website_url ?? ''} onChange={text('website_url')} placeholder="https://…" /></label>
    </div>
  )
}
